var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.742,
    height: 108.99,
    viewBox: "0 0 77.742 108.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(-136.5 -346.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.94,2.913H2.872v3.2H7.94A1.442,1.442,0,1,1,7.94,9H2.872v4.557a1.439,1.439,0,0,1-1.445,1.433A1.414,1.414,0,0,1,0,13.554V1.452A1.439,1.439,0,0,1,1.427,0H7.94a1.452,1.452,0,0,1,0,2.9Z",
    transform: "translate(136.5 439.911)",
    fill: "#ffe227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14.922,7.5A7.461,7.461,0,1,1,7.471,0,7.474,7.474,0,0,1,14.922,7.5Zm-2.914-.024A4.55,4.55,0,1,0,7.471,12.06,4.554,4.554,0,0,0,12.008,7.479Z",
    transform: "translate(147.743 440.005)",
    fill: "#ffe227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M14.922,7.5A7.461,7.461,0,1,1,7.471,0,7.474,7.474,0,0,1,14.922,7.5Zm-2.914-.024A4.55,4.55,0,1,0,7.471,12.06,4.554,4.554,0,0,0,12.008,7.479Z",
    transform: "translate(164.609 440.005)",
    fill: "#ffe227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M11.872,7.479a7.494,7.494,0,0,1-7.471,7.5H4.364L1.4,14.869A1.45,1.45,0,0,1,0,13.4V1.433A1.424,1.424,0,0,1,1.445,0H4.4a7.486,7.486,0,0,1,7.471,7.479Zm-2.891.009A4.586,4.586,0,0,0,4.4,2.908H2.891v9.11l1.539.047A4.57,4.57,0,0,0,8.982,7.489Z",
    transform: "translate(183.182 439.935)",
    fill: "#ffe227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M14.922,7.5A7.461,7.461,0,1,1,7.471,0,7.474,7.474,0,0,1,14.922,7.5Zm-2.914-.024A4.55,4.55,0,1,0,7.471,12.06a4.554,4.554,0,0,0,4.538-4.581Z",
    transform: "translate(199.32 440.005)",
    fill: "#ffe227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M61.964,60.21a34.958,34.958,0,0,1-49.371,3.973l-.136-.113L2.209,54.607a6.834,6.834,0,0,1-.535-9.515L37.891,2.373a6.648,6.648,0,0,1,9.5-.7l10.549,9.021A35.276,35.276,0,0,1,61.964,60.21ZM51.641,51.378A21.6,21.6,0,0,0,49.158,21.06l-5.387-4.609L16.2,48.97l5.345,4.864a21.328,21.328,0,0,0,30.1-2.455Z",
    transform: "translate(137.431 346.003)",
    fill: "#ffe227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M19.976,20.581A18.073,18.073,0,0,1,2.613,26.737a3.253,3.253,0,0,1,.624-6.443,3.113,3.113,0,0,1,.624.061,11.581,11.581,0,0,0,11.154-3.949A11.7,11.7,0,0,0,16.869,4.482a3.265,3.265,0,0,1,.014-2.488A3.2,3.2,0,0,1,18.639.245,3.163,3.163,0,0,1,19.868,0a3.22,3.22,0,0,1,3,2.022,18.19,18.19,0,0,1-2.891,18.56Z",
    transform: "translate(164.337 372.577)",
    fill: "#ffe227"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYellow);
export default __webpack_public_path__ + "static/media/logo_yellow.beb84060fb653816f536f4db884c2b53.svg";
export { ForwardRef as ReactComponent };